// extracted by mini-css-extract-plugin
export default {"thumbnail":"filethumbFile_thumbnail__XT4A6","thumbnailInner":"filethumbFile_thumbnailInner__RvnmP"};